import { compose } from 'redux';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core';

import Home from './Home';
import styles from './Home.styles';

const mapStateToProps = ({ user }) => ({
  user: user.data,
});

const mapDispatchToProps = null;

const HomePage = compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withStyles(styles),
)(Home);

export default HomePage;
